<div class="intro-animation-wrap">
    <div class="name-wrap" #introAnimation>
        <div *ngFor="let letter of textArr">{{letter}}</div>
    </div>
</div>